// extracted by mini-css-extract-plugin
export var button = "s-module--button--e99d0";
export var contactFloatingButton = "s-module--contactFloatingButton--94724";
export var expanded = "s-module--expanded--bbf33";
export var hide = "s-module--hide--76318";
export var whats_buttonWrapper = "s-module--whats_buttonWrapper--ec155";
export var whats_wrapper = "s-module--whats_wrapper--4a1f7";